import FreightTab from "./tabs/FreightTab/FreightTab";
import { InventoryTab } from "./tabs/InventoryTab/InventoryTab";
import { PurchaseTab } from "./tabs/PurchaseTab/PurchaseTab";
import { ShipmentTab } from "./tabs/ShipmentTab/ShipmentTab";
import { SuppliersTab } from "./tabs/SuppliersTab/SuppliersTab";
import { WarehousesTab } from "./tabs/WarehouseTab/WarehouseTab";

export const tabs = [
  {
    key: "inventoryOverview",
    label: "Inventory overview",
    children: <InventoryTab />,
  },
  {
    key: "shipmentOrders",
    label: "Shipment orders",
    children: <ShipmentTab />,
  },
  {
    key: "suppliers",
    label: "Suppliers",
    children: <SuppliersTab />,
  },
  {
    key: "freightMethods",
    label: "Freight Methods",
    children: <FreightTab />,
  },
  {
    key: "warehouses",
    label: "Warehouses",
    children: <WarehousesTab />,
  },
  {
    key: "purchaseOrders",
    label: "Purchase Orders",
    children: <PurchaseTab />,
  },
];
